"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["IDLE"] = "IDLE";
    TaskStatus["RUNNING"] = "RUNNING";
    TaskStatus["CANCELED"] = "CANCELED";
    TaskStatus["FINISHED"] = "FINISHED";
})(TaskStatus || (TaskStatus = {}));
exports.default = TaskStatus;
//# sourceMappingURL=TaskStatus.js.map